import {DependencyList} from 'react';
import {useAsyncRetry} from 'react-use';
import {
  Error,
  IRequestOptions,
  List,
  Response,
} from '../api/generated/index.defs';
import {OptionItemDto} from "../api/generics.ts";

type OptFunctionType<T> = (
  params?: T,
  options?: IRequestOptions
) => Promise<Response<List<OptionItemDto<unknown>>>>;

export const useOptions = <T>(
  optFunction: OptFunctionType<T>,
  args?: T,
  deps?: DependencyList,
  err?: (errors: Error[]) => void
) =>
  useAsyncRetry(async () => {
    const response = await optFunction(args ?? undefined);
    if (response.hasErrors) {
      err && err(response.errors);
    }

    return response.data;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deps]);